import Header from './components/Header';
import Hero from './components/Hero';
import FaqSection from './components/FaqSection';
import IndexSection from './components/IndexSection';
import UpdatesSection from './components/UpdatesSection';
import CardsSection from './components/CardsSection';
import TopicsSection from './components/TopicsSection';
import AppSection from './components/AppSection';
import ContactSection from './components/ContactSection';
import RankingSection from './components/RankingSection';
import CarouselSection from './components/CarouselSection';
import MediaSection from './components/MediaSection';
import FeaturesSection from './components/FeaturesSection';
import AboutSection from './components/AboutSection';
import CommentsSection from './components/CommentsSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <FaqSection />
        <IndexSection />
        <UpdatesSection />
        <CardsSection />
        <TopicsSection />
        <AppSection />
        <ContactSection />
        <RankingSection />
        <CarouselSection />
        <MediaSection />
        <FeaturesSection />
        <AboutSection />
        <CommentsSection />
      </main>
      <Footer />
    </div>
  );
}